import styled from "styled-components";

const AboutContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export default AboutContainer;
